'use client';
"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommandSeparator = exports.CommandItem = exports.CommandGroup = exports.CommandEmpty = exports.CommandList = exports.CommandInput = exports.Command = void 0;
exports.CommandDialog = CommandDialog;
exports.CommandShortcut = CommandShortcut;
const jsx_runtime_1 = require("react/jsx-runtime");
const React = __importStar(require("react"));
const cmdk_1 = require("cmdk");
const components_1 = require("@aiq/icons/components");
const utils_1 = require("../utils");
const dialog_1 = require("./dialog");
// Command palette / searchable list (cmdk-based). Inside Combobox it shares
// the popover surface; standalone CommandDialog gets the modal treatment.
const Command = React.forwardRef((_a, ref) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return ((0, jsx_runtime_1.jsx)(cmdk_1.Command, Object.assign({ className: (0, utils_1.cn)('flex h-full w-full flex-col overflow-hidden rounded-md bg-surface text-neutral-900', className), ref: ref }, props)));
});
exports.Command = Command;
Command.displayName = cmdk_1.Command.displayName;
function CommandDialog(_a) {
    var { children } = _a, props = __rest(_a, ["children"]);
    return ((0, jsx_runtime_1.jsx)(dialog_1.Dialog, Object.assign({}, props, { children: (0, jsx_runtime_1.jsx)(dialog_1.DialogBody, { className: 'overflow-hidden p-0 shadow-lg', children: (0, jsx_runtime_1.jsx)(Command, { className: '[&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:font-semibold [&_[cmdk-group-heading]]:text-neutral-500 [&_[cmdk-group]:not([hidden])_~[cmdk-group]]:pt-0 [&_[cmdk-group]]:px-2 [&_[cmdk-input-wrapper]_svg]:h-5 [&_[cmdk-input-wrapper]_svg]:w-5 [&_[cmdk-input]]:h-12 [&_[cmdk-item]]:px-2 [&_[cmdk-item]]:py-3 [&_[cmdk-item]_svg]:h-5 [&_[cmdk-item]_svg]:w-5', children: children }) }) })));
}
const CommandInput = React.forwardRef((_a, ref) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (
    // eslint-disable-next-line react/no-unknown-property -- cmdk's own hook attribute; its styling targets [cmdk-input-wrapper]
    (0, jsx_runtime_1.jsxs)("div", { className: 'flex items-center border-b border-neutral-100 px-3', "cmdk-input-wrapper": '', children: [(0, jsx_runtime_1.jsx)(components_1.SearchIcon, { className: 'mr-2 h-4 w-4 shrink-0 text-neutral-400' }), (0, jsx_runtime_1.jsx)(cmdk_1.Command.Input, Object.assign({ className: (0, utils_1.cn)('flex h-11 w-full rounded-md bg-transparent py-3 text-sm text-neutral-900 outline-none placeholder:text-neutral-400 disabled:cursor-not-allowed disabled:opacity-50', className), ref: ref }, props))] }));
});
exports.CommandInput = CommandInput;
CommandInput.displayName = cmdk_1.Command.Input.displayName;
const CommandList = React.forwardRef((_a, ref) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (0, jsx_runtime_1.jsx)(cmdk_1.Command.List, Object.assign({ className: (0, utils_1.cn)('max-h-[300px] overflow-y-auto overflow-x-hidden p-1', className), ref: ref }, props));
});
exports.CommandList = CommandList;
CommandList.displayName = cmdk_1.Command.List.displayName;
const CommandEmpty = React.forwardRef((props, ref) => (0, jsx_runtime_1.jsx)(cmdk_1.Command.Empty, Object.assign({ className: 'py-6 text-center text-sm text-neutral-500', ref: ref }, props)));
exports.CommandEmpty = CommandEmpty;
CommandEmpty.displayName = cmdk_1.Command.Empty.displayName;
const CommandGroup = React.forwardRef((_a, ref) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return ((0, jsx_runtime_1.jsx)(cmdk_1.Command.Group, Object.assign({ className: (0, utils_1.cn)('overflow-hidden p-1 text-neutral-900 [&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:py-1.5 [&_[cmdk-group-heading]]:text-[11px] [&_[cmdk-group-heading]]:font-bold [&_[cmdk-group-heading]]:uppercase [&_[cmdk-group-heading]]:tracking-[0.06em] [&_[cmdk-group-heading]]:text-neutral-500', className), ref: ref }, props)));
});
exports.CommandGroup = CommandGroup;
CommandGroup.displayName = cmdk_1.Command.Group.displayName;
const CommandSeparator = React.forwardRef((_a, ref) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (0, jsx_runtime_1.jsx)(cmdk_1.Command.Separator, Object.assign({ className: (0, utils_1.cn)('-mx-1 h-px bg-neutral-100', className), ref: ref }, props));
});
exports.CommandSeparator = CommandSeparator;
CommandSeparator.displayName = cmdk_1.Command.Separator.displayName;
const CommandItem = React.forwardRef((_a, ref) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return ((0, jsx_runtime_1.jsx)(cmdk_1.Command.Item, Object.assign({ className: (0, utils_1.cn)('relative flex cursor-pointer select-none items-center rounded-lg px-2.5 py-1.5 text-sm text-neutral-900 outline-none transition-colors', 'aria-selected:bg-primary-50 aria-selected:text-primary-800 hover:bg-neutral-50', 'data-[disabled=true]:cursor-not-allowed data-[disabled=true]:opacity-50', className), ref: ref }, props)));
});
exports.CommandItem = CommandItem;
CommandItem.displayName = cmdk_1.Command.Item.displayName;
function CommandShortcut(_a) {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (0, jsx_runtime_1.jsx)("span", Object.assign({ className: (0, utils_1.cn)('ml-auto text-[11px] tracking-[0.08em] text-neutral-400', className) }, props));
}
CommandShortcut.displayName = 'CommandShortcut';
